"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _Fab = _interopRequireDefault(require("../Fab"));

var _Flex = _interopRequireDefault(require("../Flex"));

var _Section = _interopRequireDefault(require("./Section"));

var _Facebook = _interopRequireDefault(require("./assets/Facebook"));

var _Instagram = _interopRequireDefault(require("./assets/Instagram"));

var _Linkedin = _interopRequireDefault(require("./assets/Linkedin"));

var _Twitter = _interopRequireDefault(require("./assets/Twitter"));

var _useTheme2 = _interopRequireDefault(require("../styles/useTheme"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var useStyles = function useStyles() {
  var _useTheme = (0, _useTheme2["default"])(),
      spacing = _useTheme.spacing;

  return {
    root: {
      margin: spacing(2.5, 0)
    },
    social: {
      marginRight: spacing(2),
      '&:last-of-type': {
        margin: 0
      }
    }
  };
};

__signature__(useStyles, "useTheme{{ spacing }}", function () {
  return [_useTheme2["default"]];
});

var SocialLink = function SocialLink(props) {
  var classes = useStyles();
  return (0, _core.jsx)(_Fab["default"], (0, _extends2["default"])({
    as: "a",
    color: "primary",
    css: classes.social,
    target: "_blank"
  }, props));
};

__signature__(SocialLink, "useStyles{classes}", function () {
  return [useStyles];
});

var Social = function Social(props) {
  var socialLinks = props.socialLinks;
  var classes = useStyles();
  return (0, _core.jsx)(_Section["default"], null, (0, _core.jsx)(_Flex["default"], {
    css: classes.root
  }, socialLinks.facebookLink ? (0, _core.jsx)(SocialLink, {
    href: socialLinks.facebookLink,
    "aria-label": "Facebook"
  }, (0, _core.jsx)(_Facebook["default"], null)) : null, socialLinks.linkedInLink ? (0, _core.jsx)(SocialLink, {
    href: socialLinks.linkedInLink,
    "aria-label": "LinkedIn"
  }, (0, _core.jsx)(_Linkedin["default"], null)) : null, socialLinks.instagramLink ? (0, _core.jsx)(SocialLink, {
    href: socialLinks.instagramLink,
    "aria-label": "Instagram"
  }, (0, _core.jsx)(_Instagram["default"], null)) : null, socialLinks.twitterLink ? (0, _core.jsx)(SocialLink, {
    href: socialLinks.twitterLink,
    "aria-label": "Twitter"
  }, (0, _core.jsx)(_Twitter["default"], null)) : null));
};

__signature__(Social, "useStyles{classes}", function () {
  return [useStyles];
});

var _default = Social;
var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(useStyles, "useStyles", "/builds/bA1zbJom/0/gojob/ui-bits/src/Footer/Social.tsx");
  reactHotLoader.register(SocialLink, "SocialLink", "/builds/bA1zbJom/0/gojob/ui-bits/src/Footer/Social.tsx");
  reactHotLoader.register(Social, "Social", "/builds/bA1zbJom/0/gojob/ui-bits/src/Footer/Social.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Footer/Social.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();